import { useDispatch } from 'react-redux'
import { AnyAction } from 'redux'
import { ThunkDispatch as ReduxThunkDispatch } from 'redux-thunk'
import { AppStateType } from '../utils/appStateReduxStore'
// Use throughout your app instead of plain `useDispatch` and `useSelector`

export type ThunkDispatch = ReduxThunkDispatch<AppStateType, null, AnyAction>

export const useAppDispatch = () => useDispatch<ThunkDispatch>()
